import { cnMixCard } from '@consta/uikit/MixCard'

import css from './HeaderTinyPopover.css'

export const internalClassName = cnMixCard({ border: true }, [css.container])
